// @flow
import * as types from '../ACTIONS/commonActionTypes';
import initialState from './commonInitialState';

export default function magReducer(state = initialState.magInfo, ourClientId: number, action) {

    switch (action.type) {
        case types.CLEAR_MAG_AND_SAMPLES: {
            return initialState.magInfo;
        }
        case types.GET_MAGINFO_SUCCESS: {
            return {
                initialized: true, ...action.magInfo
            };
        }
        case types.GOT_MARK_SECTION_FULL: {
            const newState = {...state};
            if (action.section === 0) {
                newState.sectionA.isFull = action.isFull;
            } else if (action.section === 1) {
                newState.sectionB.isFull = action.isFull;
            } else if (action.section === 2) {
                newState.sectionC.isFull = action.isFull;
            } else if (action.section === 3) {
                newState.sectionD.isFull = action.isFull;
            } else { // no change
                console.error("unknown section number in GOT_MARK_SECTION_FULL");
                return (state);
            }
            return newState;
        }
        default:
            return (state);
    }
}

